import { render, staticRenderFns } from "./priser.vue?vue&type=template&id=2ef3045e&"
import script from "./priser.vue?vue&type=script&lang=js&"
export * from "./priser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports